export default __webpack_public_path__ + "static/adorno4-fa6ec2bfe10d6579ddf1219a91adf7b9.png";